import { useMutation, useQuery } from "react-query"
import { useMainContext } from "../../../../contexts/main"
import { makeQueryFilters } from "../../../../utils/query-maker"
import { filterFetch, normalFetch } from "../../../fetch-api/get"
import { useQueryContext } from "../../../../contexts/query"
import { putApi } from "../../../fetch-api/put"
import { postApi } from "../../../fetch-api/post"

export const useGetAllAccounts = (filters, pagination, extra, csv) => {
    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery('get-all-acc', () => filterFetch(params, 'fiats/admin'), {
        cacheTime: 0,
    })
}


export const useGetVAs = (filters, pagination, extra, csv) => {
    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery('get-all-vas', () => filterFetch(params, 'fiats/admin/va'), {
        cacheTime: 0,
    })
}

export const useApproveVa = (onSuccess) => {
    const { queryClient } = useQueryContext()

    return useMutation(
        'approve-va',
        (id) => putApi({}, `fiats/admin/va/${id}`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('get-all-vas')
                onSuccess && onSuccess()
            },
        }
    )
}

export const useResubmitVa = (onSuccess) => {
    const { queryClient } = useQueryContext()

    return useMutation(
        'resubmit-va',
        (id) => postApi({}, `fiats/admin/account/resubmit/${id}`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('get-all-vas')
                onSuccess && onSuccess()
            },
        }
    )
}


export const useGetAllRecipients = () => {
    return useQuery('get-all-recipients', () => normalFetch(`fiats/admin/recipients`), {
        cacheTime: 0,

    })
}

export const useGetARecipients = (id) => {
    return useQuery('get-a-recipients', () => normalFetch(`fiats/admin/recipients/${id}`), {
        cacheTime: 0,
        select: (res) => res?.data?.data
    })
}

export const useGetAnAccount = (id) => {
    return useQuery('get-an-account', () => normalFetch(`fiats/admin/${id}`), {
        cacheTime: 0,
        select: (res) => res?.data?.data
    })
}

export const useGetRFI = (id, enable, callback) => {

    const { setToast } = useQueryContext();

    return useQuery('get-rfi', () => normalFetch(`fiats/admin/rfi/users/${id}`), {
        cacheTime: 0,
        enabled: !!id && !!enable,
        select: (res) => res?.data,
        onSuccess: (res) => {
            if (res?.data.length === 0) {
                setToast({
                    isError: true,
                    show: true,
                    message: 'This user has no RFI data',
                })
            }
            callback()
        },
        onError: () => { callback() }
    })
}
export const useGetAnAccountLatestStatus = (id, enable, update, callback) => {

    const { setToast } = useQueryContext();

    return useQuery('get-an-account-latest-status', () => normalFetch(`fiats/admin/direct/${id}?isUpdate=${!!update}`), {
        cacheTime: 0,
        enabled: !!id && !!enable,
        select: (res) => res?.data,
        onSuccess: (res) => {
            if (res?.data.length === 0) {
                setToast({
                    isError: true,
                    show: true,
                    message: 'This user has no latest status data',
                })
            }
            callback()
        },
        onError: () => { callback() }
    })
}

export const useGetSubmissionLink = (ksubId, userId, callback) => {

    return useQuery('get-submission-link', () => normalFetch(`fiats/admin/${userId}/submission/${ksubId}`), {
        cacheTime: 0,
        enabled: !!userId && !!ksubId,
        select: (res) => res?.data,
        onSuccess: (res) => {
            callback()
        },
        onError: () => { callback() }
    })
}

